import api from 'service/api'

const dponetAPIWithoutError = api.create('dponet', false)

const redirect = async ({ ...params }) => {
  return await dponetAPIWithoutError.get(`/sso_corporate_groups/redirect`, {
    params,
  })
}

export default {
  redirect,
}
